import { InputNumber } from 'antd'

function ANTDInputNumber({ ...props }) {
  return <InputNumber {...props} />
}
export default ANTDInputNumber
